// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"c786ce5c","79":"b317ed16","453":"63fea4b7"}[chunkId] + ".chunk.js";
};